// Tooltip.js
import React from 'react';
const Tooltip = ({ children, text }) => {
    return (
        <div className="tooltip-container">
            {children}
            <div className={`${!text ? 'tool' : 'tooltip'}`}>{text}</div>
        </div>
    );
};

export default Tooltip;
